export default {
  CREATE_COURSE: "CREATE_COURSE",
  LOAD_COURSES: "LOAD_COURSES",
  UPDATE_COURSE: "UPDATE_COURSE",
  DELETE_COURSE: "DELETE_COURSE",
}
